













































































import SimpleMap from '../../core/components/SimpleMap.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import ManualFactors from './ManualFactors.vue';
import IgnoredPeriods from './IgnoredPeriods.vue';
import CardVehicleSettings from './CardVehicleSettings.vue';
import UncalibratedAreaByDay from './UncalibratedAreaByDay.vue';
import CalibrationPeriods from './CalibrationPeriods.vue';
import CardLevMapa from './CardLevMapa.vue';
import CardVehicleCalibrations from './CardVehicleCalibrations.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    formatDate
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import { getVariablesConfigurationsSorted } from '../utils';

@Component({
    components: {
        Loading,
        SimpleMap,
        SimpleTable,
        Combobox,
        Button,
        ManualFactors,
        IgnoredPeriods,
        CardVehicleSettings,
        UncalibratedAreaByDay,
        CardLevMapa,
        CalibrationPeriods,
        CardVehicleCalibrations
    }
})
export default class RanchSettingsPerVehicle extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    vehicleCsvs: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    configurations: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    manualFactors: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    ignoredPeriods: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    uncalibratedItems: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    calibrationPeriods: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    itemsCalibrations: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    cropTypes: Array<object>;
    @Prop({ default: -1 }) ranchId: number;
    @Prop({ default: null }) lowFlow: any | null;
    @Prop({ default: -1 }) vehicleID: number;
    @Prop({ default: -1 }) vehicleVin: number;
    @Prop({ default: '' }) vehicleDescription: string;
    previewError: string = '';
    vehicleVariables: Array<object> = [];
    headersConfigurations: Array<object> = [
        {
            text: 'Vehículo',
            value: 'vehicle',
            sortable: true
        },
        {
            text: 'Delay',
            value: 'delay',
            sortable: true
        },
        {
            text: 'Ancho de trabajo',
            value: 'delay',
            sortable: true
        },
        {
            text: 'Variable',
            value: 'variable',
            sortable: true
        },
        {
            text: 'Tipo calibración',
            value: 'calibration_type',
            sortable: true
        }
    ];

    getCurrentVehicleID() {
        return this.vehicleID;
    }

    getCalibrations() {
        return this.getParsedCalibrations(this.itemsCalibrations);
    }

    getErrorLapses() {
        return this.getListWithVehicleId(this.ignoredPeriods);
    }

    getManualFactors() {
        let items = this.manualFactorsEl.getCurrentManualFactors();
        return this.getListWithVehicleId(items);
    }

    getConfigurations() {
        return this.getParsedVehicleConfigs(this.configurations);
    }

    getDayVehicleArea() {
        return this.getListWithVehicleId(this.uncalibratedItems);
    }

    @Emit()
    previewSimulation(data) {
        return {
            previewData: data,
            vehicle: {
                id: this.vehicleID,
                vin: this.vehicleVin,
                description: this.vehicleDescription
            }
        };
    }

    get canPreview() {
        this.previewError = '';
        if (this.configurations.length == 0) {
            this.previewError = 'Debe incluir al menos una configuración';
            return false;
        }
        return true;
    }

    mounted() {
        this.getVehicleVariables();
    }

    getVehicleVariables() {
        this.vehicleVariables = [];
        if (this.vehicleID !== -1) {
            InsuranceServices.getVehiclesVariables(this.vehicleID)
                .then(res => {
                    this.vehicleVariables = getVariablesConfigurationsSorted(res['variable_configurations']);
                })
                .catch(err => {
                    this.vehicleVariables = [];
                });
        }
    }

    disabledLevMapa(item) {
        // console.log('disabledLevMapa', item);
    }

    disabledConfigurationRow(item) {
        // console.log('disabled setting', item);
    }

    disabledIgnoredPeriod(item) {
    //     console.log('disabled ignored period');
    }

    disabledManualFactor(item) {
        // console.log('disabled manual factor', item);
    }

    getParsedVehicleConfigs(configs) {
        if (configs.length > 0) {
            configs = configs.map(function(item) {
                return {
                    ...item,
                    work_variable:
                        item['work_variable'] && item['work_variable']['id'] ? item['work_variable']['id'] : null,
                    blacklisted_variables: item['blacklisted_variables'].length > 0 ?  item['blacklisted_variables'].map(s => s['id']) : []
                };
            });
        }
        return configs;
    }

    getParsedCalibrations(calibrations) {
        let self = this;
        return calibrations.map(function(item) {
            return {
                ...item,
                force_no_telemetry: item['forced_no_telemetry'],
                humidity_variable:
                    item['humidity_variable'] && item['humidity_variable']['id']
                        ? item['humidity_variable']['id']
                        : null,
                weight_variable:
                    item['weight_variable'] && item['weight_variable']['id'] ? item['weight_variable']['id'] : null,
                vehicle_id: self.vehicleID
            };
        });
    }

    get manualFactorsEl(): HTMLFormElement {
        return this.$refs.sctManualFactorSimulator as HTMLFormElement;
    }

    getListWithVehicleId(list) {
        let self = this;
        if (list.length !== 0) {
            list = list.map(function(item) {
                return {
                    ...item,
                    vehicle: self.vehicleID
                };
            });
        }
        return list;
    }
}
